<template>
    <div class="frame">
        <div class="splash-anim-container">
            <splash></splash>
            <download-panel></download-panel>
        </div>
        <div class="content">
            <carousel></carousel>
        </div>
    </div>
</template>

<script setup lang="ts">
import Carousel from "@/components/Carousel.vue";
import DownloadPanel from "@/components/DownloadPanel.vue";
import Splash from "@/components/Splash.vue";
</script>

<style scoped>
.frame {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.splash-anim-container {
    width: 33%;
    display: flex;
    flex-direction: column;
    align-content: center;
}

.content {
    display: flex;
    flex-direction: column;
    align-content: center;
    width: 66%;
}

@media screen and (max-width: 768px) {
    .frame {
        display: block;
        height: calc(var(--body-size) - .5em);
        overflow-y: auto;
    }

    .splash-anim-container {
        width: 100%;
    }

    .content {
        width: 100%;
        align-items: center;
    }
}
</style>
